import { Chart } from '@askable/ui/illustrations';
import { cn, illustrationToneClass } from '@askable/ui/lib/utils';

import type { ReactNode } from 'react';

type EmptyStateProps = {
  title?: string;
  description?: string;
  icon?: ReactNode;
  align?: 'center' | 'start';
  children?: ReactNode;
};

export const EmptyState = ({ title, description, icon, align = 'center', children }: EmptyStateProps) => {
  return (
    <div
      data-testid="empty-state"
      className={cn(
        // max-h limits the box that the content centres itself in. With h-full alone
        // a page-level empty state fills the whole main grid row, which leaves a small
        // lockup alone in the middle of a very tall column. The cap applies only where
        // the container is taller, so a dialog or a card does not change.
        `flex h-full max-h-[30rem] min-h-44 w-full flex-col items-center justify-center gap-3 text-pretty px-4 text-center text-sm text-muted-foreground`,
        { 'justify-start py-6': align === 'start' },
      )}
    >
      <div className={cn(illustrationToneClass, '[&>svg]:size-12')}>{icon ?? <Chart />}</div>
      {title || description ? (
        <div className="flex flex-col gap-2">
          {/* text-md explicitly. Without it the 16px comes from a bare `h3` rule in
              the legacy stylesheet, which leaves the title on the wrapper's `sm`
              leading and goes away with that sheet. */}
          {title ? <h3 className="text-md font-semibold">{title}</h3> : null}
          {description ? <p className="text-pretty">{description}</p> : null}
        </div>
      ) : null}
      {children}
    </div>
  );
};
